import { CompanyConfig, TimeFormat } from '../interface';

// TODO: need update!!!
export const CeriseConfig: CompanyConfig = {
  id: 'd93a174a-d1f7-4504-97d5-c075dd86d0f0',
  lang: 'fr',
  langs: ['en', 'fr'],
  name: 'Cerise',
  nameSecondary: 'Cerise',
  currency: 'xaf',
  officialName: 'Cerise',
  email: 'commande.cerise@priximportbgg.com',
  feedbackEmail: 'commande.cerise@priximportbgg.com',
  phonePlaceholder: '+241',
  defaultPhoneCode: '+241',
  phoneNumber: '+241 77575280',
  ageRestricted: 18,
  timeZone: 'Africa/Libreville',
  minimalOrderFeeThreshold: 700,
  address: 'CCJQ+V52, Libreville, Gabon',
  canonical: '',
  defaultVolumeDisplay: '',
  warehouse: {
    default: 'CERIS',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 0.4321542633025673,
      lng: 9.437890599726877,
    },
  },
  map: {
    center: { lat: 0.398938, lng: 9.452872 },
    zoom: 12,
  },
  paymentMethods: [],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    // whatsapp: 'https://wa.me/971501515042',
    facebook: 'https://www.facebook.com/people/Cerisega/61565888469534/#',
    instagram: 'https://www.instagram.com/cerise.ga?igsh=ZHRubThlZDM5OXk3',
    tiktok: 'https://www.tiktok.com/@cerise.ga?_t=ZM-8vAeynVs1OI',
    // youtube: 'https://www.youtube.com/channel/UCzwC746u4WxzAs0fPOMfSMA/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://click.jiffy.shop/PZKk/f11c621',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  countryCode: 'GA',
  license: {
    name: 'Cerise',
    numberPrinary: '',
  },
};
